import styled from "@emotion/styled";
import PanelTab from "./PanelTab";
import { Box, Icon } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { CDashboardModuleTab, SidePanelExt } from "../../types";

const SidePanelWrapper = styled.div`
	height: calc(100vh - 20px);
	width: 50px;
	box-sizing: content-box;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	&:hover {
		overflow-y: auto;
	}
	padding-top: 10px;
	padding-bottom: 10px;
`;

export interface SidePanelProps {
	menuTabs: CDashboardModuleTab[];
	sidePanelExt?: SidePanelExt[];
}

const SidePanel: React.FC<SidePanelProps> = ({ menuTabs, sidePanelExt }) => {
	const navigate = useNavigate();
	const navigateToLanding = () => {
		navigate("/dashboard/landing");
	};
	return (
		<SidePanelWrapper>
			<Box style={{ border: "none", marginBottom: "20px", textAlign: "center", cursor: "pointer" }}>
				<Icon onClick={navigateToLanding} style={{ padding: "5px", borderRadius: "10px", width: "24px", backgroundColor: "#319af6", color: "white" }}>
					widgets
				</Icon>
			</Box>
			{menuTabs && menuTabs.map((tab, index) => <PanelTab key={index} title={tab.title} icon={tab.icon} path={tab.path} />)}
			<Box sx={{ flexGrow: "1" }}></Box>
			{sidePanelExt && sidePanelExt.map((ext, index) => <PanelTab key={index} title={ext.title} icon={ext.icon} path={ext.path} onClick={ext.onClick} />)}
		</SidePanelWrapper>
	);
};

export default SidePanel;
